<template lang="html">
    <div class="container-fluid p-5">
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h5 class="mb-0">Enrollment List</h5>
                        <div class="d-flex align-items-center">
                            <button class="btn btn-success fbutton mr-2" v-b-modal.bv-modal-csv-upload  @click="uploadModal()">
                                <i class="fas fa-upload"></i> Import CSV
                            </button>
                            <router-link to="enrollment-create" class="btn btn-primary">
                                <i class="fas fa-plus"></i> New Enrollment
                            </router-link>
                            <button v-if="user.type == 'a1'" v-b-modal.bv-modal-add-reduce class="btn btn-warning fbutton ml-2" @click="openAddReduceModal()">
                                <i class="fas fa-plus-minus"></i> Add/Reduce Amount
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row search-form">
                            <div class="col-md-3 mt-1">
                                <input type="text" v-model="filter.search_batch" class="form-control" placeholder="Search by Batch Code, Batch Name">
                            </div>
                            <div class="col-md-3 mt-1">
                                <input type="text" v-model="filter.search_fee" class="form-control" placeholder="Search by Fee Code, Fee Name">
                            </div>
                            <div class="col-md-3 mt-1">
                                <input type="text" v-model="filter.search_student" class="form-control" placeholder="Search by Student Code, Student Name">
                            </div>
                            <div class="col-md-3 mt-1">
                                <select v-model="filter.status" class="form-control">
                                    <option value="">Select Status</option>
                                    <option value="pending">Pending</option>
                                    <option value="inactive">Inactive</option>
                                    <option value="partial">Partial</option>
                                    <option value="paused">Paused</option>
                                    <option value="dropped">Dropped</option>
                                    <option value="done">Done</option>
                                </select>
                            </div>
                            <div class="col-md-3 mt-1">
                                <input onfocus="(this.type='date')" v-model="filter.date_from"  class="form-control" placeholder="From Date">
                            </div>
                            <div class="col-md-3 mt-1">
                                <input onfocus="(this.type='date')" v-model="filter.date_to" class="form-control" placeholder="To Date">
                            </div>
                            <div class="col-md-3 mt-1">
                                <button class="btn btn-primary mr-1 fbutton" @click="search()"><i class="fas fa-search"></i> Search</button>
                                <button class="btn btn-info fbutton" @click="reset()"><i class="fas fa-sync"></i> Refresh</button>
                            </div>
                        </div>
                        <div class="table-responsive mt-4">
                            <table class="common-table">
                                <thead>
                                    <tr>
                                        <th v-for="(value, key) in visibleColumns" :key="key" @click="sortBy(key)" style="cursor:pointer">
                                            {{ value }}
                                            <span v-if="filter.sort_by === key">
                                                <i v-if="filter.orderBy === 'asc'" class="fas fa-sort-up"></i>
                                                <i v-else class="fas fa-sort-down"></i>
                                            </span>
                                        </th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(data, index) in dataList" :key="data.id">
                                        <td>{{ data.batch.code1 }}{{ data.batch.code2 }}{{ data.batch.code3 }}</td>
                                        <td>{{ data.fee.code }}</td>
                                        <td>{{ data.payment_terms.name }}</td>
                                        <td>{{ data.student.student_code }}</td>
                                        <td>{{ data.student.name }}</td>
                                        <td v-if="user.type == 'a1'">{{ data.original_amount }}</td>
                                        <td>{{ data.discount_amount }}</td>
                                        <td>{{ data.amount }}</td>
                                        <td v-if="user.type == 'a1'">{{ data.remain_amount }}</td>
                                        <td>{{ data.enrollment_date }}</td>
                                        <td>
                                            <span v-if="data.status == 'pending'" class="badge badge-primary">Pending</span>
                                            <span v-else-if="data.status == 'inactive'" class="badge badge-danger">Inactive</span>
                                            <span v-else-if="data.status == 'transferred'" class="badge badge-danger">Transferred</span>
                                            <span v-else-if="data.status == 'partial'" class="badge badge-info">Partial</span>
                                            <span v-else-if="data.status == 'paused'" class="badge badge-warning">
                                                <button @click="changeOptionModal(data)" v-b-modal.bv-modal-status-change class="badge-16 btn btn-warning p-0 m-0" data-toggle="tooltip" data-placement="top" title="Paused" >Paused</button>
                                            </span>
                                            <span v-else-if="data.status == 'dropped'" class="badge badge-secondary">
                                                <button @click="changeOptionModal(data)" v-b-modal.bv-modal-status-change class="badge-16 btn btn-secondary p-0 m-0" data-toggle="tooltip" data-placement="top" title="Paused" >Dropped</button>
                                            </span>
                                            <span v-else-if="data.status == 'done'" class="badge badge-success">Done</span>
                                            
                                        </td>
                                        <td>
                                            <button class="btn btn-option text-default" @click="editAliasData(data)" v-if="data.alias_change_request == true"><i class="fas fa-copy"></i></button>
                                            <button class="btn btn-option text-primary" @click="editData(data)"><i class="fas fa-edit"></i></button>
                                            <!-- <button v-b-modal.bv-modal-delete class="btn btn-option text-danger" @click="deleteData(data)"><i class="fas fa-trash-alt"></i></button> -->
                                        </td>
                                    </tr>
                                    <tr v-if="dataList.length > 0" class="table-summary font-weight-bold text-white" style="background-color: #4e8889;">
                                        <td class="text-center" :colspan="(visibleColumnsCount >= 5 ? 5 : visibleColumnsCount)">
                                           TOTAL
                                        </td>
                                        <td v-if="user && user.type == 'a1'">{{ totalData.original_amount }}</td>
                                        <td>{{ totalData.discount_amount }}</td>
                                        <td>{{ totalData.amount }}</td>
                                        <td v-if="user.type == 'a1'">{{ totalData.remain_amount }}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr v-if="dataList.length === 0">
                                        <td :colspan="Object.keys(columns).length + 1" class="text-center">Empty List</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="table-pagination-minimal">
                            <div class="table-pagination-row">
                                <div v-if="dataList.length > 0 " class="table-info-minimal left-align">
                                    Showing <span>{{metaData.from}}</span> to <span>{{metaData.to}}</span> of <span>{{metaData.total}}</span> entries
                                </div>
                                <nav class="pagination-minimal">
                                    <ul>
                                        <li :class="{ 'disabled': metaData.prev_page_url === null }">
                                            <button @click.prevent="next(metaData.current_page-1)" :disabled="metaData.prev_page_url === null">
                                                <i class="fas fa-angle-left"></i>
                                            </button>
                                        </li>
                                        <li v-for="page in metaData.last_page" :key="page"
                                            :class="{ 'active':metaData.current_page === page }"
                                            v-if="Math.abs(page - metaData.current_page) < 3 || page == metaData.last_page || page == 1">
                                            <button @click.prevent="next(page)">{{ page }}</button>
                                        </li>
                                        <li :class="{ 'disabled': metaData.current_page === metaData.last_page }">
                                            <button @click.prevent="next(metaData.current_page+1)" :disabled="metaData.current_page === metaData.last_page">
                                                <i class="fas fa-angle-right"></i>
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                        <b-modal id="bv-modal-delete" ref="my-modal" title="Delete" hide-footer>
                            <p class="my-4">Are you sure to delete ? </p>
                            <p class="my-4 text-danger">{{alert}}</p>
                            <b-button class="mt-3 btn-danger" block @click="deleteItem()">Delete</b-button>
                        </b-modal>
                        
                        <!-- CSV Upload Modal -->
                        <b-modal id="bv-modal-csv-upload" ref="csv-modal" title="Import Enrollments (CSV)" hide-footer size="md">
                            <template>
                                <div v-if="uploadMessage" :class="uploadMessageType === 'success' ? 'alert alert-success' : 'alert alert-danger'">
                                    {{ uploadMessage }}
                                </div>
                                <div v-if="errors.length">
                                    <b-form-group label="">
                                        <b-list-group>
                                            <b-list-group-item v-for="(error, index) in errors" :key="index" class="text-danger">
                                                Row: {{ error.row }}<br />
                                                Column: {{ error.column }}<br />
                                                Error: {{ error.error }}
                                            </b-list-group-item>
                                        </b-list-group>
                                    </b-form-group>
                                </div>
                                <div class="form-group">
                                    <label for="csvFile">Select CSV File</label>
                                    <input 
                                        type="file" 
                                        id="csvFile" 
                                        ref="csvFileInput"
                                        @change="onFileSelect" 
                                        accept=".csv" 
                                        class="form-control"
                                    />
                                    <small class="form-text text-muted">
                                        Please upload a CSV file with the required enrollment data format.
                                    </small>
                                </div>
                                <div class="form-group" v-if="selectedFile">
                                    <strong>Selected File:</strong> {{ selectedFile.name }}<br>
                                    <strong>Size:</strong> {{ formatFileSize(selectedFile.size) }}
                                </div>
                                <div class="d-flex justify-content-between">
                                    <b-button variant="secondary" @click="closeUploadModal()">Cancel</b-button>
                                    <b-button variant="primary" @click="uploadCSV()" :disabled="!selectedFile || isUploading">
                                        <span v-if="isUploading">
                                            <i class="fas fa-spinner fa-spin"></i> Uploading...
                                        </span>
                                        <span v-else>
                                            <i class="fas fa-upload"></i> Upload
                                        </span>
                                    </b-button>
                                </div>
                            </template>
                        </b-modal>
                        <!-- Status Change Modal Select Box -->
                        <b-modal id="bv-modal-status-change" ref="status-change-modal" title="Enrollment Option" hide-footer>
                            <template>
                                <!-- confirm box -->
                                 <p class="my-4">Are you sure to change enrollment option to next enrollment ? </p>
                                <b-button class="mt-3 btn-primary" block @click="changeOption()">Confirm</b-button>
                            </template>
                        </b-modal>
                        <b-modal id="bv-modal-add-reduce" ref="add-reduce-modal" title="Add Extra Amount / Reduce Amount" hide-footer>
                            <template>
                                <div class="form-group">
                                    <select id="typeSelect" class="form-control" v-model="type">
                                        <option value="">Select Type</option>
                                        <option value="all_add_amount">Add Reduce Amount (Filter Search Batch)</option>
                                        <option value="all_remove_amount">Remove Reduce Amount (Filter Search Batch)</option>
                                    </select>
                                </div>  
                                <div class="form-group" v-if="type == 'all_add_amount'">
                                    <label for="extraReduceAmount">Amount</label>
                                    <input type="number" id="extraReduceAmount" class="form-control" v-model="extra_reduce_amount" placeholder="Enter amount">
                                </div>
                                <div class="d-flex justify-content-between">
                                    <b-button variant="secondary" @click="$refs['add-reduce-modal'].hide()">Cancel</b-button>
                                    <b-button variant="primary" @click="addReduce()" >
                                        <i class="fas fa-save"></i> Save
                                    </b-button>
                                </div>
                            </template>
                        </b-modal>
                        
                        <!-- <router-link class="float" to="enrollment-create">
                            <i class="fa fa-plus my-float" style="padding: 37%;"></i>
                        </router-link> -->
                    </div> <!-- close card-body -->
                </div> <!-- close card -->
            </div> <!-- close col-md-12 -->
        </div> <!-- close row -->
    </div> <!-- close container-fluid -->
</template>

<script lang="js">
    import {
        mapState,
        mapActions
    } from 'vuex'
    import env from '../../enviorments'
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css';
    export default {
        name: 'enrollmentList',
        metaInfo: {
            title: "Enrollment List",
            titleTemplate: "%s ← MIC",
        },
        components: {
            Loading
        },
        data() {
            return {
                env,
                isLoading: false,
                fullPage: true,
                user: null,
                alert: "",
                type: '',
                extra_reduce_amount: '',
                id: '',
                selected_enrollment_option: '',
                dataList: [],
                totalData: [],
                commissionData: [],
                permissions: '',
                errors: [],
                columns: {
                    batch_id: "Batch Code",
                    fee_id: "Fee Code",
                    payment_terms_id: "Payment Terms",
                    student_code: "Student Code",
                    name: "Student Name",
                    original_amount: "Original Fee",
                    discount_amount: "Discount Amount",
                    amount: "Total Fee",
                    remain_amount: "Remaining Amount",
                    enrollment_date: "Enrollment Date",
                    status: "Received Status",
                },
                filter: {
                    page: 1,
                    per_page: 20,
                    sort_direction: "asc",
                    sort_by: "created_at",
                    limit: 20,
                    search_batch: '',
                    search_fee: '',
                    search_student: '',
                    status: '',
                    date_from: '',
                    date_to: ''
                },
                metaData: {
                    last_page: null,
                    current_page: 1,
                    from: null,
                    to: null,
                    total: null,
                    prev_page_url: null
                },
                // CSV Upload related data
                selectedFile: null,
                isUploading: false,
                uploadMessage: '',
                uploadMessageType: 'success'
            }
        },
        watch: {
        '$route' (to, from) {
            this.fetchData()
        }
    },
        computed: {
            visibleColumns() {
                // return columns but omit original_amount unless user.type == 'a1'
                const cols = Object.assign({}, this.columns);
                if (!(this.user && this.user.type == 'a1')) {
                    delete cols.original_amount;
                    delete cols.remain_amount;
                }
                return cols;
            },
            visibleColumnsCount() {
                return Object.keys(this.visibleColumns).length;
            }
        },
        methods: {
            ...mapActions({
                enrollmentListAction: 'enrollmentListAction',
                bankDeleteAction: 'bankDeleteAction',
                enrollmentImportAction: 'enrollmentImportAction',
                enrollmentTotalAction: 'enrollmentTotalAction',
                extraReduceAction: 'extraReduceAction'
            }),
            async addReduce(data) {
				this.isLoading = true
                
				const formData = new FormData();
				formData.append('type', this.type);
                formData.append('add_amount', this.extra_reduce_amount);

                if(this.type == "individual_add_amount"){
                    formData.append('enrollment_id', data.id);
                }else{
                    formData.append('search_batch', this.filter.search_batch);
                }

				await this.extraReduceAction(
					formData
				).then(res => {
					if(res.success === true) {
                        this.fetchData()
                        this.$refs['add-reduce-modal'].hide()
					} else {
						this.message = res.message
					}
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
            sortBy(column) {
                this.filter.sort_by = column
                if (this.filter.sort_by == column) {
                    if (this.filter.sort_direction == "asc") {
                        this.filter.sort_direction = "desc"
                    } else if (this.filter.sort_direction == "desc") {
                        this.filter.sort_direction = "asc"
                    }
                } else {
                    this.filter.sort_direction = "asc"
                }
                this.fetchData()
            },
            async search() {
                this.filter.page = 1
                this.fetchData()
                this.$refs['my-modal'].hide()
            },
            async fetchData() {
                this.isLoading = true
                // Update the page query parameter in the URL
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        ...this.$route.query,
                        page: this.filter.page
                    }
                });
                let option = this.filter
                await this.enrollmentListAction({
                    ...option
                }).then(res => {
                    if (res.success == true) {
                        this.dataList = res.data.data
                        this.metaData.last_page = res.data.meta.last_page
                        this.metaData.current_page = res.data.meta.current_page
                        this.metaData.prev_page_url = res.data.meta.prev_page_url
                        this.metaData.from = res.data.meta.from
                        this.metaData.to = res.data.meta.to
                        this.metaData.total = res.data.meta.total
                        this.isLoading = false;

                        // Fetch total data
                        this.fetchTotalData()
                    }
                }).catch(err => this.isLoading = true)
            },
            async fetchTotalData() {
                this.isLoading = true
                // Update the page query parameter in the URL
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        ...this.$route.query,
                        page: this.filter.page
                    }
                });
                let option = this.filter
                await this.enrollmentTotalAction({
                    ...option
                }).then(res => {
                    if (res.success == true) {
                        this.totalData = res.data
                        this.isLoading = false;
                    }
                }).catch(err => this.isLoading = true)
            },
            next: function (page) {
                this.filter.page = page
                this.fetchData();
            },
            reset(){
                this.$router.replace({ 
                    path: 'enrollment-list', 
                    query: {
                        page: 1, 
                        per_page: 10,
                        sort_direction: 'desc', 
                        sort_by: 'created_at',
                        search_batch: '',
                        search_fee: '',
                        search_student: '',
                        status: '',
                        date_from: '',
                        date_to: ''
                    } 
                }).catch(()=>{})
                this.$router.go()
            },
            editData(data) {
                this.$router.replace({ 
                    path: 'enrollment-edit', 
                    query: { 
                        page: this.filter.page,
                        per_page: this.filter.per_page,
                        sort_direction: this.filter.sort_direction, 
                        sort_by: this.filter.sort_by, 
                        id: data.id,
                        search_batch: this.filter.search_batch,
                        search_fee: this.filter.search_fee,
                        search_student: this.filter.search_student,
                        status: this.filter.status,
                        date_from: this.filter.date_from,
                        date_to: this.filter.date_to
                    } 
                }).catch(()=>{})
            },
            editAliasData(data) {
                this.$router.replace({ 
                    path: 'enrollment-alias-edit', 
                    query: { 
                        page: this.filter.page,
                        per_page: this.filter.per_page,
                        sort_direction: this.filter.sort_direction, 
                        sort_by: this.filter.sort_by, 
                        id: data.id,
                        search_batch: this.filter.search_batch,
                        search_fee: this.filter.search_fee,
                        search_student: this.filter.search_student,
                        status: this.filter.status,
                        date_from: this.filter.date_from,
                        date_to: this.filter.date_to
                    } 
                }).catch(()=>{})
            },
            deleteData(data){
                this.id = data.id
                this.alert = ""
            },
            async deleteItem() {
				this.isLoading = true
				let option = {
					id: this.id,
				}
				await this.bankDeleteAction({
					...option
				}).then(res => {
					if(res.status == 'fail'){
                        this.alert = res.message
                    }else{
                        this.$refs['my-modal'].hide()
                    }
                    this.fetchData()
                    this.isLoading = false;
				}).catch(err => this.isLoading = true)
			},
            checkPermission: function (key) {
                if(key in this.permissions){
                    return true
                }else{
                    return false
                }
            },
            // CSV Upload Methods
            onFileSelect(event) {
                this.selectedFile = event.target.files[0];
                this.uploadMessage = '';
            },
            formatFileSize(bytes) {
                if (bytes === 0) return '0 Bytes';
                const k = 1024;
                const sizes = ['Bytes', 'KB', 'MB', 'GB'];
                const i = Math.floor(Math.log(bytes) / Math.log(k));
                return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
            },
            async uploadCSV() {
                this.errors = [];
                if (!this.selectedFile) {
                    this.uploadMessage = 'Please select a CSV file to upload.';
                    this.uploadMessageType = 'error';
                    return;
                }

                // Validate file type
                if (!this.selectedFile.name.toLowerCase().endsWith('.csv')) {
                    this.uploadMessage = 'Please select a valid CSV file.';
                    this.uploadMessageType = 'error';
                    return;
                }

                this.isUploading = true;
                this.uploadMessage = '';

                try {
                    const formData = new FormData();
                    formData.append('csv_file', this.selectedFile);

                    const response = await this.enrollmentImportAction(formData);
                    
                    if (response.success) {
                        console.log('CSV Upload Response:', response);
                        this.uploadMessage = response.message || 'CSV uploaded successfully!';
                        this.uploadMessageType = 'success';
                        
                        // Refresh the enrollment list
                        this.fetchData();
                        
                        // Close modal after 2 seconds
                        setTimeout(() => {
                            this.closeUploadModal();
                        }, 2000);
                    } else {
                        this.errors = response.error ? response.error[0] : [];
                        console.log('CSV Upload Error:', this.errors);
                        this.uploadMessage = 'Upload failed. Please try again.';
                        this.uploadMessageType = 'error';
                    }
                } catch (error) {
                    console.log('CSV Upload Error:', error);
                    this.uploadMessage = 'An error occurred during upload. Please try again.';
                    this.uploadMessageType = 'error';
                } finally {
                    this.isUploading = false;
                }
            },
            uploadModal() {
                this.selectedFile = null;
                this.uploadMessage = '';
                this.uploadMessageType = 'success';
                this.errors = [];
                this.isUploading = false;
            },
            closeUploadModal() {
                this.selectedFile = null;
                this.uploadMessage = '';
                this.uploadMessageType = 'success';
                this.isUploading = false;
                
                // Reset file input
                if (this.$refs.csvFileInput) {
                    this.$refs.csvFileInput.value = '';
                }
                
                // Hide modal
                this.$refs['csv-modal'].hide();
            },
            changeOptionModal(data) {
                this.id = data.id
                this.selected_enrollment_option = ''
            },
            changeOption() {
                    //redirect to enrollment option page
                    this.$router.replace({ 
                    path: 'enrollment-option', 
                    query: { 
                        page: this.filter.page,
                        per_page: this.filter.per_page,
                        sort_direction: this.filter.sort_direction, 
                        sort_by: this.filter.sort_by, 
                        id: this.id,
                        search_batch: this.filter.search_batch,
                        search_fee: this.filter.search_fee,
                        search_student: this.filter.search_student,
                        status: this.filter.status,
                        date_from: this.filter.date_from,
                        date_to: this.filter.date_to
                    } 
                }).catch(()=>{})  
            }

        },
        mounted() {
            const userStr = window.localStorage.getItem('user');
            console.log(userStr)
            if (userStr) {
                try {
                    this.user = JSON.parse(userStr);
                } catch (e) {
                    this.user = null;
                }
            }
            // assign permissions safely from this.user (user variable may be undefined)
            this.permissions = this.user && this.user.permissions ? this.user.permissions : ''
            this.filter.page = this.$route.query.page
            this.filter.per_page = this.$route.query.per_page
            this.filter.sort_by = this.$route.query.sort_by
            this.filter.sort_direction = this.$route.query.sort_direction
            this.filter.search_batch = this.$route.query.search_batch
            this.filter.search_fee = this.$route.query.search_fee
            this.filter.search_student = this.$route.query.search_student
            this.filter.status = this.$route.query.status
            this.filter.date_from = this.$route.query.date_from
            this.filter.date_to = this.$route.query.date_to
            this.fetchData()
        }
    }
</script>
<style scoped lang="scss">
/* Large commission modal custom width */
.commission-modal-lg .modal-dialog {
    max-width: 900px;
}
   .badge-16 {
    font-size: 16px;
   }
</style>